import {
    MenuItemProps,
    useRuntimeEnv,
    useTranslationLang,
    useTranslationRoute,
    useTranslations,
} from "@bsm/component";
import { useMemo } from "react";
import { useLangMenuItems } from "../../layout/hooks/useLangMenuItems";

export const useAvatarMenuItems = () => {
    const { runtimeEnv } = useRuntimeEnv();
    const [PROFILE, LOGOUT] = useTranslations(i18nKeys);
    const translationRoute = useTranslationRoute();
    const itemsLang = useLangMenuItems();
    const isInAdmin = location.pathname.split("/").includes("admin");
    const { lang } = useTranslationLang();
    const isAuthenticated = !!runtimeEnv?.user?.id;

    return useMemo((): Array<MenuItemProps> => {
        const langItems: Array<MenuItemProps> = [...itemsLang];
        if (!isAuthenticated) {
            return langItems;
        }
        return [
            {
                label: PROFILE,
                link: translationRoute(
                    `${isInAdmin ? "admin/" : ""}user/${runtimeEnv?.user
                        .id}/about`
                ),
                startIcon: "fa-solid fa-user",
            },
            {
                divide: true,
            },
            {
                label: LOGOUT,
                "data-testid": "avatar-menu-logout",
                link: translationRoute(`logout`),
                startIcon: "fa-solid fa-right-from-bracket",
            },
        ];
    }, [lang, isAuthenticated, PROFILE, LOGOUT, itemsLang, isInAdmin]);
};

const i18nKeys = ["std_profil", "std_logout"];